"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.FormattedCurrency = void 0;
var _react = _interopRequireDefault(require("react"));
var _getLocale = _interopRequireDefault(require("../../utils/getLocale"));
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/jsx-props-no-spreading */

/** 
  - Passed through values for country and language should form a valid locale when combined
* */
const FormattedCurrency = ({
  config,
  data,
  ...props
}) => {
  const {
    country,
    language,
    mask
  } = config;
  const locale = (0, _getLocale.default)(country, language);
  const formatted = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: mask
  }).format(data);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    className: "ccl-e-formatted-currency",
    "data-testid": mask,
    ...props,
    children: formatted
  });
};
exports.FormattedCurrency = FormattedCurrency;
FormattedCurrency.defaultProps = {
  config: {
    country: 'US',
    language: 'en',
    mask: 'USD'
  }
};